module.exports = __webpack_public_path__ + "1.5.0-unryo/img/analytics.c05fb81d.jpg";